import type SchemeQuoteResult from './SchemeQuoteResult'
import { JsonObject, JsonProperty } from 'json2typescript'
import PaymentTypeEnumConverter from '../../converters/PaymentTypeEnumConverter'
import { PaymentTypeEnum } from '../enums/DLDCommonValuesEnum'
import { DefinedListDetail } from './DefinedList'
import QuoteDetails from './QuoteDetails'

@JsonObject('CaravanQuoteDetails')
export default class CaravanQuoteDetails extends QuoteDetails<SchemeQuoteResult> {
  @JsonProperty('voluntaryExcess', DefinedListDetail)
  voluntaryExcess: DefinedListDetail = new DefinedListDetail()
}

@JsonObject('CaravanMTAQuoteDetails')
export class CaravanMTAQuoteDetails extends CaravanQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('hasUpgradableVAP', Boolean)
  hasUpgradableVAP = false

  @JsonProperty('message', String)
  message = ''

  @JsonProperty('hasClaims', Boolean)
  hasClaims = false
}

@JsonObject('CaravanRenewalQuoteDetails')
export class CaravanRenewalQuoteDetails extends CaravanQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('previousPolicyScheme', String)
  previousPolicyScheme = ''
}
